module.exports = __webpack_public_path__ + "static/media/Img-02.6b70b87d.jpg";